import type { PreparedAction } from "../action-doc-builder"
import type { Narrative } from "./create-narrative"

export interface Payload {
  context?: Record<string, any> | null
  titleForAnalytics: string
}

export default function analyticsOnly(payload: Payload): PreparedAction {
  return {
    name: "ANALYTICS",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative(findFn: Function, _userId: string): Narrative | null {
      return {
        titleForAnalytics: payload.titleForAnalytics,
        context: payload.context || {},
      }
    },
  }
}
